// @ts-nocheck
/* eslint-disable */
export const arrowBackIosIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M400-80 0-480l400-400 56 57-343 343 343 343-56 57Z"/></svg>`,
    name: 'arrow-back-ios' as const
};